<script lang="ts">
  import type { Storefront } from "@shared/types/Storefront";
  export let storefront: Storefront;
  import FeaturedProduct from "./FeaturedProduct.svelte";

</script>

{#if storefront.enable_featured_items}
  <section data-grid-area="breakout" id="featured_items">
    <div class="fizz-flex-row-responsive" style="justify-content: center;">
      <FeaturedProduct {storefront} orientation={"left"} maxHeight={"375px"} />
      <FeaturedProduct {storefront} orientation={"right"} maxHeight={"375px"} />
    </div>
  </section>
{/if}
